export default "__VITE_ASSET__DYritDNN__"